export const GET_ALL_MEBEBER_BENEFITS_DATA = "GET_ALL_MEBEBER_BENEFITS_DATA";
export const GET_MEBEBER_DETAILS = "GET_MEBEBER_DETAILS";
export const GET_HERO_MEMEBER_DETAILS = "GET_HERO_MEMEBER_DETAILS";
export const SET_MEMBER_LIST_STATUS = "SET_MEMBER_LIST_STATUS";
export const MEBEBER_DETAILS_STATUS = "MEBEBER_DETAILS_STATUS";
export const RESET_MEMBER_DETAILS = "RESET_MEMBER_DETAILS";
